import { Theme } from '../../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import React from 'react';
import ManagerInsuranceCompaniesCaseTypeDeleteModal from './ManagerInsuranceCompaniesCaseTypeDeleteModal';
import { useDisclose } from '../../../../../Modal/Hooks/useDisclose';

interface Props {
	id: string;
	reloadData: () => void;
}

const ManagerInsuranceCompaniesCaseTypeDelete = ({ id, reloadData }: Props) => {
	const { isOpen, onOpen, onClose } = useDisclose();

	return (
		<>
			<LinkButton
				title='base.shared.remove'
				theme={Theme.RED}
				onClick={onOpen}
			/>
			{isOpen && (
				<ManagerInsuranceCompaniesCaseTypeDeleteModal
					isOpen
					onClose={onClose}
					id={id}
					reloadData={reloadData}
				/>
			)}
		</>
	);
};

export default ManagerInsuranceCompaniesCaseTypeDelete;
